import React from 'react'
import {withFormik} from "formik";
import * as yup from "yup";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Alert from "react-bootstrap/Alert";
import {FormControl} from "react-bootstrap";
import Storage from "../Storage";
import MaskedInput from "react-maskedinput";
import jwtClient from '../JwtClient'

export const noReportIntervalHour = '';
export const noReportAt = '';

class ProfileAddModal extends React.Component {

    render() {
        const {
            show,
            handleClose,
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            status,
            resetForm,
        } = this.props;
        let error;
        if (status && status.error) {
            error = <Alert variant="danger">{status.error}</Alert>
        }
        return (
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {Storage.getEmail()}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error}
                    <div>
                        <h6>Package reports</h6>
                    </div>
                    <Form.Group>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>
                                    Every
                                </InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                as="select"
                                name="reportIntervalHour"
                                value={values.reportIntervalHour}
                                onChange={handleChange}
                            >
                                <option value={noReportIntervalHour}>Disabled</option>
                                {[1, 3, 6, 12, 24].map((value, index) => {
                                    return <option key={index} value={value}>{value}h</option>
                                })}
                            </FormControl>
                        </InputGroup>
                    </Form.Group>

                    <Form.Group>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>
                                    At
                                </InputGroup.Text>
                            </InputGroup.Prepend>
                            <MaskedInput
                                className={this.getMarkedInputClass(touched.reportAt, !!errors.reportAt)}
                                name="reportAt"
                                disabled={
                                    values.reportIntervalHour === noReportIntervalHour ||
                                    values.reportIntervalHour < 12
                                }
                                value={values.reportAt}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                mask="11:00"
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.at}
                            </Form.Control.Feedback>
                        </InputGroup>
                        <Form.Text className="text-muted">
                            New York timezone (24h)
                        </Form.Text>
                    </Form.Group>

                    <hr/>

                    <a href="/" onClick={this.logout}>Logout</a>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={(event) => {
                        handleClose(event);
                        resetForm();
                    }}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    logout = () => {
        Storage.clear();
        window.location.replace('/');
    };

    getMarkedInputClass = (isTouched, hasError) => {
        if (isTouched && hasError) {
            return 'form-control is-invalid'
        } else {
            return 'form-control'
        }
    };
}

export default withFormik({
    mapPropsToValues: () => ({
        reportIntervalHour: Storage.getReportIntervalHour(),
        reportAt: Storage.getReportAt(),
    }),
    validationSchema: yup.object().shape({
        reportIntervalHour: yup.number(),
        reportAt: yup.string().matches(/([0-1][0-9]|2[0-3]):00/, 'Invalid'),
    }),
    handleSubmit: (values, formikBag) => {
        let data = {
            'report_interval_hour': values.reportIntervalHour || null,
        };
        if (values.reportIntervalHour >= 12) {
            data['report_at'] = values.reportAt;
        } else {
            data['report_at'] = null;
        }
        jwtClient.put('/api/v1/client/report', data)
            .then(response => {
                if (response.status === 200) {
                    formikBag.setSubmitting(false);
                    Storage.setReportIntervalHour(values.reportIntervalHour);
                    Storage.setReportAt(values.reportAt);
                    formikBag.props.handleClose();
                    formikBag.resetForm();
                } else {
                    formikBag.setStatus({error: 'Cannot update'})
                }
            })
            .catch(() => {
                formikBag.setStatus({error: 'The service has responded with an error! Contact the administrators to resolve the issue!'});
            });
    },
})(ProfileAddModal);
